import { Button } from "@compass/core";
import DnsIcon from '@mui/icons-material/Dns';
import Tooltip from '@mui/material/Tooltip';


interface ManageButtonProps {
    onClick: () => void;
}

export const ManageButton = ({ onClick }: ManageButtonProps) => {
    return (
        <Tooltip title="Manage dashboard cards">
            <Button
                variant="contained"
                startIcon={<DnsIcon />}
                onClick={onClick}
                aria-label="Manage dashboard cards"
            >
                Manage Cards
            </Button>
        </Tooltip>
    );
};